import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import weekDay from 'dayjs/plugin/weekday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(isBetween);
dayjs.extend(weekDay);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(utc);
dayjs.extend(timezone);

@Injectable()
export class DateService {
	/**
	 * Returns a new instance of DayJs
	 */
	public create(date?: Date | string): dayjs.Dayjs {
		return dayjs(date);
	}

	public tz(date: string, timezone: string) {
		return dayjs.tz(date, timezone);
	}
}
